import { useTranslation } from "react-i18next";
import React from "react";
import { resendEmailNotification } from "../../../../../../axios/api/services";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/emailNotificationsControl";

const ResendEmailNotificationDialog = ({ filterFn }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.emailNotificationsControl.modals.resend;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "resend" }));
  };

  const onSuccess = () => {
    handleCloseDialog();
    filterFn();
    toast.success(t("m.save.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => resendEmailNotification(id)}
      onSuccess={onSuccess}
      title={"t.email.notification.resend.dialog"}
      message={"m.resend.email.notification.warning.message"}
    />
  );
};

export default ResendEmailNotificationDialog;
